(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-home-slider-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const heroes = document.querySelectorAll('[data-hcs-hero]');
    heroes.forEach(function (hero) {
      const slides = hero.querySelectorAll('[data-hcs-slide]');
      const dots = hero.querySelectorAll('[data-hcs-dot]');
      const counter = hero.querySelector('[data-hcs-counter]');
      const total = slides.length;
      if (total <= 1) return;

      const autoplay = parseInt(hero.dataset.autoplay, 10) || 7000;
      let current = 0;
      let timer = null;
      let paused = false;

      function format(n) {
        return String(n).padStart(2, '0');
      }

      function go(next) {
        if (next === current) return;
        slides[current].classList.remove('is-active');
        dots[current] && dots[current].classList.remove('is-active');
        current = (next + total) % total;
        // Force reflow to restart progress animation
        const activeDot = dots[current];
        if (activeDot) {
          const fill = activeDot.querySelector('.hcs-hero__dot-fill');
          if (fill) { fill.style.animation = 'none'; void fill.offsetWidth; fill.style.animation = ''; }
          activeDot.classList.add('is-active');
        }
        const activeZoom = slides[current].querySelector('.hcs-slide__zoom');
        if (activeZoom) { activeZoom.style.animation = 'none'; void activeZoom.offsetWidth; activeZoom.style.animation = ''; }
        slides[current].classList.add('is-active');
        if (counter) counter.textContent = format(current + 1);
      }

      function start() {
        stop();
        if (paused) return;
        timer = window.setTimeout(function () { go(current + 1); start(); }, autoplay);
      }

      function stop() {
        if (timer) { window.clearTimeout(timer); timer = null; }
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          const target = parseInt(dot.dataset.hcsDot, 10);
          go(target);
          start();
        });
      });

      hero.addEventListener('mouseenter', function () { paused = true; stop(); });
      hero.addEventListener('mouseleave', function () { paused = false; start(); });

      if (!document.hidden) start();
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else { start(); }
      });

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        stop();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
